function getLighthouseScore(value) {
  if (value > 100 || value < 0) {
    throw new Error(`param.value must be between 0 - 100 `)
  }

  return value > 89 ? `good` : value > 49 ? `average` : `bad`
}

export default getLighthouseScore
